import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/pages/container';
import reference from '@/subpages/reference.vue';
import services from '@/subpages/services.vue';
import contact from '@/subpages/contact.vue';
import impressum from '@/subpages/impressum.vue';
import datenschutz from '@/subpages/datenschutz.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '',
      name: 'Home',
      component: HomePage,
      children: [
        {
          path: "",
          component: services
        },
        {
          path: "referenzen",
          component: reference
        },
        {
          path: "kontakt",
          component: contact
        },
        {
          path: "impressum",
          component: impressum
        },
        {
          path: "datenschutz",
          component: datenschutz
        },
      ]
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js